/** @type {import('../schema').ProcessDefinition} */
const gestionUsuarios = {
  id: "gestion-usuarios",
  name: "Gestión de usuarios y admins",
  category: "personas",
  outcome:
    "El Super Admin da de alta/edita admins y residentes, con credenciales y reset de contraseña.",
  trigger: "El Super Admin abre Administradores o Residentes.",
  actors: ["Super Admin", "Sistema", "Administrador"],
  status: "COMPLETO",
  description:
    "Alta, edición y baja de admins y residentes por el Super Admin, con provisioning de Auth y reset de contraseña.",
  lanes: [
    { id: "sa", actor: "Super Admin" },
    { id: "sys", actor: "Sistema" },
    { id: "target", actor: "Administrador" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "sa",
      type: "start",
      label: "Captura de datos",
      description:
        "Nombre, documento, email, celular y rol del usuario a crear.",
      evidence: "src/screens/admin/GestionAdmins.jsx, src/screens/admin/Cuentas.jsx",
    },
    {
      id: "s2",
      laneId: "sys",
      type: "task",
      label: "Validación + anti-duplicado",
      description:
        "Valida el documento y busca email existente.",
    },
    {
      id: "s3",
      laneId: "sa",
      type: "decision",
      label: "¿Admin o residente?",
      description:
        "Define el camino de alta según el rol elegido.",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "task",
      label: "Alta de admin",
      description:
        "createStaffUser crea en el servidor el usuario (typeuser 1) y su cuenta Auth sin contraseña; si la respuesta trae definirContrasena, el cliente envía el correo para definirla.",
      evidence: "functions/identity/staff.js:437 (createStaffUser), src/screens/admin/GestionAdmins.jsx:208",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "task",
      label: "Alta de residente",
      description:
        "Igual que la invitación administrativa: alta y enlace tokenizado de activación.",
      evidence: "src/screens/admin/Cuentas.jsx (inviteResident)",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "notification",
      label: "Email de reset/activación",
      description:
        "Provisioning entrega al usuario el email de reset (admin) o el enlace de activación (residente).",
    },
    {
      id: "s7",
      laneId: "target",
      type: "end",
      label: "Usuario operativo",
      description:
        "Usuario activo (puede loguear). La edición posterior cambia datos no sensibles; la baja archiva la ficha (archivedAt: removeStaffUser o residentAccountAction) y nunca borra el users, así se preserva el histórico.",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "Admin" },
    { from: "s3", to: "s5", label: "Residente" },
    { from: "s4", to: "s6" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};
export default gestionUsuarios;
